module.exports = __webpack_public_path__ + "img/step.831ed49f.svg";